module.exports = __webpack_public_path__ + "img/1496351255.561a72f9.jpg";